import serviceToTQInterface from 'services/tq-adapter/serviceToTQInterface';
import { OneServiceFetcherContext, OneServiceNoParams, OneServiceWithParams } from 'types/services/services';

/**
 * Build a fetcher for a service without params.
 * @param context the fetcher context
 * @returns a service fetcher for service without params.
 */
function buildFetchService(context: OneServiceFetcherContext): <Data>(service: OneServiceNoParams<Data>) => Promise<Data>;
/**
 * Build a fetcher for a service with params.
 * @param context the fetcher context
 * @returns a service fetcher for service with params.
 */
function buildFetchService(
  context: OneServiceFetcherContext,
): <Data, Params extends object>(service: OneServiceWithParams<Data, Params>) => Promise<Data>;
/**
 * Build a fetcher for a service with or without params.
 * @param context the fetcher context
 * @returns a service fetcher for service with or without params.
 */
function buildFetchService({ queryClient }: OneServiceFetcherContext) {
  /**
   * Service with or without params fetcher
   * @param service the service to use
   * @param params the params for the service
   * @returns promise of the data from the service
   */
  const fetcher = async <Data, Params extends object>(
    service: Params extends object ? OneServiceWithParams<Data, Params> : OneServiceNoParams<Data>,
    params?: Params,
  ) => {
    const options = serviceToTQInterface(queryClient, service, params);

    return queryClient.fetchQuery<Data>(options);
  };

  return fetcher;
}

export default buildFetchService;
